// ********************************************************
// Nomination
// Handles stuff like view and submit nominations.
// ********************************************************

import * as Backend from '@/core/backend'

export async function loadNominations (params) {
  const res = await Backend.callApi({
    apiName: 'Nomination.LoadNominations',
    inputData: {
      Facility: params.Facility,
      AgreementId: params.AgreementId,
      CustomerNo: params.CustomerNo,
      WasteFuelType: params.WasteFuelType,
      PlantNo: params.PlantNo,
      DateFrom: params.DateFrom,
      DateTo: params.DateTo,
      ViewType: params.ViewType,
      ActiveType: params.ActiveType,
      StateNo: params.StateNo
    }
  })
  return res
}

export async function loadAgreementLog (params) {
  const res = await Backend.callApi({
    apiName: 'Nomination.LoadAgreementLog',
    inputData: {
      AgreementId: params.AgreementId
    }
  })
  return res
}

export async function loadAgreementAndDetails (params) {
  const res = await Backend.callApi({
    apiName: 'Nomination.LoadAgreementAndDetails',
    inputData: {
      Facility: params.Facility,
      AgreementNo: params.AgreementNo
    }
  })
  return res
}

export async function loadAgreementNames (params) {
  const res = await Backend.callApi({
    apiName: 'Nomination.LoadAgreementNames',
    inputData: {
      Facility: params.Facility,
      AgreementId: params.AgreementId,
      CustomerNo: params.CustomerNo,
      WasteFuelType: params.WasteFuelType,
      PlantNo: params.PlantNo,
      DateFrom: params.DateFrom,
      DateTo: params.DateTo,
      ViewType: params.ViewType,
      ActiveType: params.ActiveType,
      StateNo: params.StateNo
    }
  })
  return res
}

export async function loadAgreementCustomers (params) {
  const res = await Backend.callApi({
    apiName: 'Nomination.LoadAgreementCustomers',
    inputData: {
      Facility: params.Facility,
      AgreementId: params.AgreementId,
      CustomerNo: params.CustomerNo,
      WasteFuelType: params.WasteFuelType,
      PlantNo: params.PlantNo,
      DateFrom: params.DateFrom,
      DateTo: params.DateTo,
      ViewType: params.ViewType,
      ActiveType: params.ActiveType,
      StateNo: params.StateNo
    }
  })
  return res
}

export async function loadAgreementPlants (params) {
  const res = await Backend.callApi({
    apiName: 'Nomination.LoadAgreementPlants',
    inputData: {
      Facility: params.Facility,
      AgreementId: params.AgreementId,
      CustomerNo: params.CustomerNo,
      WasteFuelType: params.WasteFuelType,
      PlantNo: params.PlantNo,
      DateFrom: params.DateFrom,
      DateTo: params.DateTo,
      ViewType: params.ViewType,
      ActiveType: params.ActiveType,
      StateNo: params.StateNo
    }
  })
  return res
}

export async function loadWasteFuelTypes (params) {
  const res = await Backend.callApi({
    apiName: 'Nomination.LoadWasteFuelTypes',
    inputData: {
      Facility: params.Facility
    }
  })
  return res
}

export async function saveNominations (params) {
  const res = await Backend.callApi({
    apiName: 'Nomination.SaveNominations',
    inputData: {
      Nominations: params.Nominations,
      SendEmails: params.SendEmails
    }
  })
  return res
}
